export const phoneFormatter = (value: string): string => {
  if (!value) return "";

  return value
    .replace(/\D+/g, "")
    .replace(/^(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d{4})$/, "$1 $2")
    .replace(/(\d{4})(\d{4})$/, "$1 $2");
};
